// extracted by mini-css-extract-plugin
export var wordContainer = "_r2-0";